/**
 *
 * Disclaimer
 *
 */

import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { withStyles } from '@material-ui/core/styles';
import AppContainer from 'components/AppContainer';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { arrayToSentence, replacePlaceholders } from 'utils/stringUtils';
import useSiteCopySelector from 'components/useSiteCopySelector';

const styles = theme => ({
  root: {
    padding: '20px !important',
    boxShadow: 'none !important',
    color: theme.palette.primary.contrastText,
    background: '#fff',
    fontSize: 12,
    lineHeight: 1.57,
    textAlign: 'center',
    '& p, span': {
      color: theme.palette.primary.contrastText,
      fontSize: 12,
      lineHeight: 1.57,
    },
  },
  content: {
    boxShadow: 'none',
  },
  disclaimer: {
    fontWeight: 600,
  },
});

function Disclaimer(props) {
  const {
    classes,
    type,
    person = [],
    organization = [],
    vendor = [],
    name = '',
    isGuestBlog,
  } = props;
  const [disclaimerSiteCopy] = useSiteCopySelector(['resources-disclaimer']);
  const clientDetails = useSelector(state => state.main.clientDetails);
  const combinedData = [...person, ...organization];
  const values = combinedData
    .filter(item => item.fields)
    .map(data => _get(data, 'fields.name'));
  const personOrgsAndVendors = arrayToSentence(
    [...values, ...vendor],
    _get(disclaimerSiteCopy, 'pageCopy.connector'),
  );
  if (_isEmpty(personOrgsAndVendors)) return null;
  const referenceLabel =
    [...values, ...vendor].length > 1
      ? _get(disclaimerSiteCopy, 'pageCopy.referenceLabelMultiple')
      : _get(disclaimerSiteCopy, 'pageCopy.referenceLabelSingle');
  const calledLabel = !_isEmpty(name)
    ? _get(disclaimerSiteCopy, 'pageCopy.calledLabel').replace('#name', name)
    : '';
  const clientSuffix = _isEmpty(clientDetails)
    ? ''
    : replacePlaceholders(
        _get(disclaimerSiteCopy, 'pageCopy.clientSuffix', ''),
        {
          '#clientName': _get(clientDetails, 'name'),
          '#clientFormatShortName': _get(clientDetails, 'formalShortName'),
        },
      );

  const disclaimertext = !isGuestBlog
    ? replacePlaceholders(_get(disclaimerSiteCopy, 'pageCopy.disclaimerText'), {
        '#type': type,
        '#calledLabel': calledLabel,
        '#peopleOrgs': personOrgsAndVendors,
        '#referenceLabel': referenceLabel,
        '#clientSuffix': clientSuffix,
      })
    : replacePlaceholders(
        _get(disclaimerSiteCopy, 'pageCopy.guestBlogDisclaimerText'),
        {
          '#clientSuffix': clientSuffix,
          '#clientFormatShortName': _get(clientDetails, 'formalShortName'),
        },
      );
  return (
    <AppContainer>
      <Grid item xs={12} className={classes.root}>
        <Paper className={classes.content}>
          {!isGuestBlog && (
            <span className={classes.disclaimer}>
              {_get(disclaimerSiteCopy, 'pageCopy.disclaimerHeader')}
            </span>
          )}{' '}
          {disclaimertext}
        </Paper>
      </Grid>
    </AppContainer>
  );
}

Disclaimer.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.string,
  person: PropTypes.array,
  organization: PropTypes.array,
  vendor: PropTypes.array,
  name: PropTypes.string,
  isGuestBlog: PropTypes.bool,
};

Disclaimer.defaultProps = {
  isGuestBlog: false,
};

export default withStyles(styles)(Disclaimer);
